import WithRender from "../../templates/buttons/downloadCF2Button.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {},
  methods: {
    ...mapActions(["packingDownloadCf2"]),

    onDownload: function () {
      this.packingDownloadCf2();
    }
  }
});
